import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const ThreeDIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props}>
    <path
      d='m11.98,10.85c-0.12,0 -0.24,-0.02 -0.37,-0.07l-10.37,-4.5c-0.15,-0.07 -0.27,-0.19 -0.37,-0.32c-0.1,-0.15 -0.15,-0.32 -0.15,-0.46c0,-0.17 0.05,-0.34 0.15,-0.49c0.1,-0.12 0.22,-0.24 0.37,-0.32l10.37,-4.5c0.22,-0.1 0.44,-0.1 0.66,-0.02l10.37,3.89c0.17,0.07 0.29,0.17 0.39,0.32c0.1,0.12 0.17,0.29 0.17,0.44c0,0.17 -0.02,0.34 -0.12,0.49c-0.07,0.15 -0.19,0.27 -0.37,0.34l-10.37,5.11c-0.12,0.07 -0.24,0.1 -0.37,0.1l0.01,-0.01zm-8.23,-5.36l8.2,3.55l8.23,-4.07l-8.2,-3.09l-8.23,3.6l0,0.01z'
      id='svg_1'
    />
    <path
      d='m11.98,23.92c-0.12,0 -0.24,-0.02 -0.37,-0.07l-10.37,-4.5c-0.19,-0.1 -0.37,-0.27 -0.44,-0.49c-0.07,-0.19 -0.07,-0.44 0.02,-0.63c0.1,-0.19 0.24,-0.37 0.46,-0.46c0.22,-0.07 0.44,-0.07 0.66,0l9.98,4.36l10.03,-4.94c0.19,-0.1 0.44,-0.12 0.66,-0.05c0.19,0.07 0.39,0.22 0.49,0.44c0.1,0.19 0.12,0.44 0.05,0.63c-0.07,0.22 -0.22,0.39 -0.44,0.51l-10.37,5.11c-0.12,0.07 -0.24,0.1 -0.37,0.1l0.01,-0.01z'
      id='svg_2'
    />
    <path
      d='m1.61,19.42c-0.24,0 -0.46,-0.1 -0.63,-0.27c-0.15,-0.15 -0.24,-0.37 -0.24,-0.58l0,-13.07c0,-0.24 0.1,-0.46 0.24,-0.61c0.17,-0.17 0.39,-0.27 0.63,-0.27c0.22,0 0.44,0.1 0.61,0.27c0.15,0.15 0.24,0.37 0.24,0.61l0,13.07c0,0.22 -0.1,0.44 -0.24,0.58c-0.17,0.17 -0.39,0.27 -0.61,0.27z'
      id='svg_3'
    />
    <path
      d='m22.35,18.78c-0.24,0 -0.46,-0.07 -0.63,-0.24c-0.15,-0.17 -0.24,-0.37 -0.24,-0.61l0,-13.07c0,-0.22 0.1,-0.44 0.24,-0.61c0.17,-0.15 0.39,-0.24 0.63,-0.24c0.22,0 0.44,0.1 0.61,0.24c0.15,0.17 0.24,0.39 0.24,0.61l0,13.07c0,0.24 -0.1,0.44 -0.24,0.61c-0.17,0.17 -0.39,0.24 -0.61,0.24z'
      id='svg_4'
    />
    <path
      d='m11.98,23.92c-0.24,0 -0.46,-0.1 -0.63,-0.24c-0.15,-0.17 -0.24,-0.39 -0.24,-0.61l0,-13.07c0,-0.22 0.1,-0.44 0.24,-0.61c0.17,-0.15 0.39,-0.24 0.63,-0.24c0.22,0 0.44,0.1 0.61,0.24c0.15,0.17 0.24,0.39 0.24,0.61l0,13.07c0,0.22 -0.1,0.44 -0.24,0.61c-0.17,0.15 -0.39,0.24 -0.61,0.24z'
      id='svg_5'
    />
  </SvgIcon>
)
